import GradientCard from "components/Common/GradientCard";
import { PiHandCoinsBold, PiCoinsBold, PiMoneyFill } from "react-icons/pi";

const ICON_SIZE = 24;

interface IBusinessStats {
  businessStats: BusinessStatsType;
}
const BusinessStats: React.FC<IBusinessStats> = ({ businessStats }) => {
  const statsList = [
    {
      title: "Total amount customers spent at your business",
      amount: businessStats?.totalTransactionAmount,
      topBorderColor: "skyBlue",
      sideGradientColors: { from: "#1AC8ED", to: "#5F72BE" },
      iconBg: "bg-skyBlue",
      iconColor: "text-white",
      textColor: "text-skyBlue",
      icon: <PiMoneyFill size={ICON_SIZE} />,
    },
    {
      title: "Rewards your customers earned",
      amount: businessStats?.totalRewardsDistributed,
      topBorderColor: "orange",
      sideGradientColors: { from: "#FF1654", to: "#FF8C42" },
      iconBg: "bg-orange",
      iconColor: "text-white",
      textColor: "text-orange",
      icon: <PiCoinsBold size={ICON_SIZE} />,
    },
    {
      title: "Rewards your customers redeemed",
      amount: businessStats?.totalRedeemAmount,
      topBorderColor: "pink",
      sideGradientColors: { from: "#FF37A6", to: "#A93FFD" },
      iconBg: "bg-pink",
      iconColor: "text-white",
      textColor: "text-pink",
      icon: <PiHandCoinsBold size={ICON_SIZE} />,
    },
  ];
  return (
    <>
      {/* For Desktop View */}
      <div className="hidden md:grid grid-cols-3 md:gap-6 gap-4">
        {statsList?.map((stat, index) => (
          <GradientCard
            key={index}
            topBorderColor={stat.topBorderColor}
            sideGradientColors={stat.sideGradientColors}
            className="h-full min-w-0"
          >
            <div className="p-6 min-h-[200px] flex flex-col justify-start">
              {stat.icon && (
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center ${stat.iconBg} mb-4`}
                >
                  <div className={stat.iconColor}>{stat.icon}</div>
                </div>
              )}
              <div className="flex-1 text-gray-800 font-poppins font-medium text-base leading-tight tracking-normal mb-4 max-w-[220px]">
                {stat.title}
              </div>
              <div
                className={`text-2xl font-bold font-poppins ${stat.textColor}`}
              >
                ${stat.amount}
              </div>
            </div>
          </GradientCard>
        ))}
      </div>
      {/* For Mobile View - Single Combined Card */}
      <div className="bg-white border-2 border-skyBlue border-opacity-50 border-t-8 rounded-2xl p-4 md:hidden">
        {statsList?.map((stat, index) => (
          <div key={index}>
            <div className="flex flex-row justify-between items-start py-3">
              <div className="text-gray-800 flex-1 pr-2 font-poppins font-medium text-sm leading-tight tracking-normal max-w-[60%] break-words">
                {stat?.title}
              </div>
              <div className="text-2xl font-bold text-black">
                ${stat?.amount}
              </div>
            </div>
            {Number(index) + 1 < statsList?.length && (
              <div className="border-t border-gray-200 w-full" />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default BusinessStats;
